// extracted by mini-css-extract-plugin
export default {"container":"MatrixTable_container__i0r3Z","intro":"MatrixTable_intro__vX6R+","table":"MatrixTable_table__x1MkB","th":"MatrixTable_th__W+w8l","td":"MatrixTable_td__rMGhm"};